module.exports = __webpack_public_path__ + "img/pc_pic_kehuduan@2x.bedf6e01.png";